var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDevicePurple = function SvgDevicePurple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.505 3.633h-8.344c-1.499 0-2.714 1.142-2.714 2.552v19.627c0 1.41 1.215 2.553 2.714 2.553h8.344c1.5 0 2.715-1.143 2.715-2.553V6.185c0-1.41-1.215-2.552-2.715-2.552Zm-8.344-2.301C9.311 1.332 7 3.505 7 6.185v19.627c0 2.68 2.31 4.853 5.161 4.853h8.344c2.85 0 5.162-2.172 5.162-4.853V6.185c0-2.68-2.311-4.853-5.162-4.853h-8.344Z",
    fill: "#7959D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7959D3",
    d: "M17.666 17.332h2.667v2h-2.667zM12.333 17.332H15v2h-2.667zM17.666 20.664h2.667v2h-2.667zM12.334 20.664h2.667v2h-2.667zM17.666 24h2.667v2h-2.667zM12.333 24H15v2h-2.667z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.96 10.624a4.401 4.401 0 1 1-8.802 0 4.401 4.401 0 0 1 8.802 0Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.611 7.122a3.555 3.555 0 1 0 0 7.11 3.555 3.555 0 0 0 0-7.11Zm-5.333 3.555a5.333 5.333 0 1 1 10.667 0 5.333 5.333 0 0 1-10.667 0Z",
    fill: "#7959D3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.008 10.624c0-.958.775-1.733 1.733-1.733h12.42a1.733 1.733 0 1 1 0 3.466h-12.42a1.733 1.733 0 0 1-1.733-1.733Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.127 10.625a2.613 2.613 0 0 1 2.614-2.613h12.42a2.613 2.613 0 0 1 0 5.226h-12.42a2.613 2.613 0 0 1-2.614-2.613Zm2.614-.853a.853.853 0 1 0 0 1.706h12.42a.853.853 0 0 0 0-1.706h-12.42Z",
    fill: "#7959D3"
  })));
};
export default SvgDevicePurple;